import React, { useEffect, useRef } from 'react'
import './style.css'

export default function IconButton({image, onClick}) {
    return (
        <img className='icon-button' src={image} onClick={onClick}></img>
    )
}
